module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_06-0b61a8a508b3ba6342b7027ecd3778ad.jpg";